import gql from 'graphql-tag';

export const createMeshElementMutation = gql`
  mutation ($input: MeshElementCreateInput) {
    createMeshElement(input: $input)
    {
      meshElementId
      name
      location
      meshModels
    }
  }
`
